export default "__VITE_ASSET__Csa$aBfp__"